export function LinearBriefcase({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66673 5.00002V4.33335C6.66673 2.85835 6.66673 1.66669 9.33339 1.66669H10.6667C13.3334 1.66669 13.3334 2.85835 13.3334 4.33335V5.00002M11.6667 11.6834C11.6667 11.675 11.6667 11.675 11.6667 11.6667V10.8334C11.6667 10 11.6667 10 10.8334 10H9.16673C8.33339 10 8.33339 10 8.33339 10.8334V11.6917M11.6667 11.6834C11.6667 12.5917 11.6584 13.3334 10.0001 13.3334C8.35006 13.3334 8.33339 12.6 8.33339 11.6917M11.6667 11.6834C13.9167 11.4 16.1167 10.5667 18.0417 9.16669M8.33339 11.6917C6.17506 11.45 4.05839 10.675 2.18339 9.39169M6.66673 18.3334H13.3334C16.6834 18.3334 17.2834 16.9917 17.4584 15.3584L18.0834 8.69169C18.3084 6.65835 17.7251 5.00002 14.1667 5.00002H5.83339C2.27506 5.00002 1.69173 6.65835 1.91673 8.69169L2.54173 15.3584C2.71673 16.9917 3.31673 18.3334 6.66673 18.3334Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
